/**
 * Issuances page — stub
 * The backend does not have a standalone issuances sub-module.
 * Asset requests are handled via direct assign/return (POST /{id}/assign, POST /{id}/return).
 * This page is kept as a placeholder and redirects users to Assignments.
 */
import { Link } from "react-router-dom";
import { PackageCheck, ArrowRight } from "lucide-react";
import { BackBtn, PageHeader } from "../components/AssetUI";

export default function AssetIssuancesPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumb="Asset Management"
        title="Asset Issuances"
        actions={<BackBtn to="/assets" label="Dashboard" />}
      />
      <div className="flex flex-col items-center justify-center rounded-2xl border-2 border-dashed border-slate-200 bg-slate-50 py-20 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-indigo-50">
          <PackageCheck className="h-8 w-8 text-indigo-400" />
        </div>
        <h3 className="mt-4 text-lg font-semibold text-slate-700">Handled via Assignments</h3>
        <p className="mt-2 max-w-sm text-sm text-slate-400">
          Asset issuance in this system is handled directly through the Assignments workflow —
          select an available asset and assign it to an employee.
        </p>
        <Link to="/assets/assignments"
          className="mt-6 inline-flex items-center gap-2 rounded-xl bg-indigo-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700">
          Go to Assignments <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
